import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from "@apollo/client";

// 기존 DEV_SERVER_URL 정의를 환경 변수를 사용하도록 변경합니다.
// REACT_APP_DEV_SERVER_URL이라는 환경 변수를 사용하고, 없으면 기존 URL을 기본값으로 사용합니다.
// Mixed Content 방지를 위해 HTTP URL을 HTTPS로 강제 변환
const getServerUrl = () => {
  const url = process.env.REACT_APP_API_URL || "https://api.a-pex.co.kr/graphql";
  // HTTP로 시작하는 경우 HTTPS로 변환
  if (url.startsWith("http://")) {
    return url.replace("http://", "https://");
  }
  return url;
};

const SERVER_URL = getServerUrl();

const httpLink = new HttpLink({ uri: SERVER_URL });

const authLink = new ApolloLink((operation, forward) => {
  const accessToken = localStorage.getItem("accessToken");
  operation.setContext({
    headers: {
      authorization: accessToken ? `Bearer ${accessToken}` : null,
    },
  });
  return forward(operation);
});

export const client = new ApolloClient({
  // link: httpLink,
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
